import { render, staticRenderFns } from "./CompanionContentCard.vue?vue&type=template&id=65b3cea2&scoped=true&lang=pug&"
import script from "./CompanionContentCard.vue?vue&type=script&lang=js&"
export * from "./CompanionContentCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanionContentCard.vue?vue&type=style&index=0&id=65b3cea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b3cea2",
  null
  
)

export default component.exports